var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bar-chart-wrapper"},[_c('apexchart',{key:_vm.chartKey,attrs:{"type":"bar","height":"320","options":_vm.normalizedOptions,"series":_vm.normalizedSeries}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }